import { render, staticRenderFns } from "./CopyRow.vue?vue&type=template&id=6e8a8cea&scoped=true"
import script from "./CopyRow.vue?vue&type=script&lang=js"
export * from "./CopyRow.vue?vue&type=script&lang=js"
import style0 from "./CopyRow.vue?vue&type=style&index=0&id=6e8a8cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8a8cea",
  null
  
)

export default component.exports